<template>
  <div>
    <recharge-manual-ledger-list />
  </div>
</template>

<script>
import rechargeManualLedgerList from './list.vue'

export default {
  components: {
    rechargeManualLedgerList
  }
}
</script>
